import { FC, Suspense } from 'react'
import { FormCard, Text } from '@lmc/ui-kit'
import useFeatureFlags from 'hooks/useFeatureFlags'
import Field from '../../../../components/fields'
import styled from 'styled-components'
type Props = {
  homeSettings: any
  formId: string
}

export const QuickLogSettings: FC<Props> = ({ homeSettings, formId }) => {
  const flags = useFeatureFlags({
    flagNames: ['clinical_safety_seizures']
  })?.data

  return (
    <StyledFormCard title="Log Options">
      <StyledText>
        In the App, we have a default list of daily logs that cover most areas
        of care. If you would prefer your staff not use some daily logs, toggle
        them off and they will no longer appear in the Daily Logs section of the
        App. You'll need to log out of the App and log back in to see any
        changes that have been made.
        <a
          target="_blank"
          href="https://support.logmycare.co.uk/en/articles/3853371-how-can-i-hide-log-options"
          rel="noreferrer"
        >
          {' '}
          Find out more
        </a>
      </StyledText>
      <FieldWrapper>
        <Suspense fallback={<div>Loading...</div>}>
          <Field
            keys="logCategoryItems"
            displayLabel={false}
            formId={formId}
            type="logCategoryItems"
            values={homeSettings}
            hideShortSeizure={flags?.clinical_safety_seizures?.enabled}
          />
        </Suspense>
      </FieldWrapper>
    </StyledFormCard>
  )
}

const StyledFormCard = styled(FormCard)`
  margin-bottom: 50px;
`

const StyledText = styled(Text)`
  color: ${(props) => props.theme.color.neutral.color4};
  margin-top: 16px;
  margin-bottom: 16px;
`

const FieldWrapper = styled.div`
  padding-top: 12px;
`
